import Course from './course'

export default class Enrollment {
  readonly id: number
  readonly course: Course
  readonly progressPercent: number
  readonly lastLearntLessonId: number
  readonly certificateUrl: string | null

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.course = data.course
    this.progressPercent = data.progressPercent
    this.lastLearntLessonId = data.lastLearntLessonId
    this.certificateUrl = data.certificateUrl || null
  }
}
